export default function CodeEmail(userName, userMessage, userEmail) {
  return `<html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #f4f4f4;
          margin: 0;
          padding: 20px;
        }
        .email-container {
          max-width: 600px;
          margin: 0 auto;
          padding: 20px;
          background-color: #ffffff;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          border-left: 5px solid #007bff;
        }
        .email-header {
          text-align: center;
          padding-bottom: 15px;
          border-bottom: 2px solid #eee;
        }
        .email-header h2 {
          color: #007bff;
          margin: 0;
        }
        .email-content {
          padding: 20px 0;
        }
        .email-content p {
          margin: 5px 0;
          font-size: 16px;
          color: #333;
        }
        .email-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }
        .email-table th, .email-table td {
          padding: 10px;
          border: 1px solid #ddd;
          text-align: left;
        }
        .email-table th {
          background-color: #007bff;
          color: #fff;
        }
        .email-footer {
          margin-top: 20px;
          text-align: center;
          font-size: 12px;
          color: #666;
          padding-top: 10px;
          border-top: 1px solid #ddd;
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="email-header">
        </div>
        <div class="email-content">
          <p><strong>Sender:</strong> ${userName}</p>
          <table class="email-table">
            <tr>
              <th>Field</th>
              <th>Details</th>
            </tr>
            <tr>
              <td><strong>Username:</strong></td>
              <td>${userName}</td>
            </tr>
             <tr>
              <td><strong>Email:</strong></td>
              <td>${userEmail}</td>
            </tr>
            <tr>
              <td><strong>Message:</strong></td>
              <td>${userMessage}</td>
            </tr>
          </table>
        </div>
        <div class="email-footer">
          <p>This is an automated system message.</p>
          <p>&copy; 2025. Devsoftex. All rights reserved.</p>
        </div>
      </div>
    </body>
  </html>`;
}
